import React, { useEffect } from "react";
import { motion } from "framer-motion";

/* img imports */
import tinyVivaLogo from "../assets/images/tiny-viva-logo.png";

/* animation imports */
import { pageCurtainAnime, curtainLogoAnime } from "../assets/js/animations";

/* comp imports */
// import PageConfetti from "./PageConfetti";

const PageTransition = () => {
  window.scrollTo(0, 0);
  const disableScroll = () => {
    const accepted = localStorage.getItem("mainDisclaimerAccepted") === "true";
    if (accepted) {
      document.body.style.overflow = "hidden";
    }
  };

  const enableScroll = () => {
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    disableScroll();
    const timer = setTimeout(() => {
      enableScroll();
    }, 4000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      {/* <div className="confetti-wrapper d-none">
        <PageConfetti />
      </div> */}
      <motion.div
        className="page-curtain-wrapper"
        initial="initial"
        animate="animate"
        variants={pageCurtainAnime}
      >
        <motion.div
          className="page-curtain-logo"
          initial="initial"
          animate="animate"
          variants={curtainLogoAnime}
        >
          <img src={tinyVivaLogo} alt="Tiny Viva Logo" />
        </motion.div>
      </motion.div>
    </>
  );
};

export default PageTransition;
